// extracted by mini-css-extract-plugin
module.exports = {"desktop":"_4f720283bf--desktop--d5V8g","mobile":"_4f720283bf--mobile--YeYUy"};